import 'client-only';
import { logger } from '@curology/logger/client';

import { type Brand } from '@/consts/brands';
import COOKIE_KEYS from '@/consts/cookieKeys';
import cookie from '@/utils/cookies/client';
import { urls } from '@/utils/urls';

/**
 * Makes a read request to the Curology API to set the CSRF token cookie
 * The CSRF token should be sent on subsequent write requests to the Curology API
 * @see https://laravel.com/docs/10.x/csrf
 */
async function getCsrfToken(brand: Brand) {
  if (cookie.has(COOKIE_KEYS.csrf)) {
    return;
  }

  // Use native fetch rather than the http client to avoid circular reference to builder
  const response = await fetch(urls[brand].api.auth.csrf);

  if (!response.ok) {
    logger.log(
      `Get CSRF Token Failed:  ${response.status} - ${response.statusText}`,
    );
  }
}

export const AuthService = {
  getCsrfToken,
};
